import React from "react";
import {
  // HiXCircle,
  // MdSkipNext,
  IoLogoYoutube,
  // MdExitToApp
} from "react-icons/io";
import { useTranslation } from "react-i18next";

export default function ZoomAnswerVideoBottomButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        }`}
        onClick={props.onClickHandler}
        title={t("Answer Video")}
      >
        <span className="icon has-text-danger mb-2">
          <IoLogoYoutube className="fas fa-2x" />
        </span>
        <span className="has-text-light is-hidden-tablet-only  is-hidden-mobile mb-2">
          {t("Answer Video")}
        </span>
      </button>
    </>
  );
}
